import { utc } from "@date-fns/utc";
import { format } from "date-fns";
import { Timestamp } from "firebase/firestore";

export const formatDateForCalendar = (value: Timestamp) => {
  if (typeof value === "object") {
    return format(new Date(value.seconds * 1000), "y-MM-dd", {
      in: utc,
    });
  } else if (typeof value === "string") {
    return value;
  } else {
    console.error("Invalid date format received in formatDateForDisplay");
    return "ERR";
  }
};
